import {
  Box,
  IconButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import { PanelWrapper } from '../../components/shared/PanelWrapper/PannelWrapper';
import { FilterContainer } from '../../components/shared/Filter/FilterContainer';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { useQuery } from '../../utils/hooks/useQuery';
import { ClinicalStudyViewModel } from '../../types/models';
import { useState } from 'react';
import { ClinicalStudyModal } from '../../components/ClinicalStudies/ClinicalStudyModal';
import { DeleteConfirmationPopover } from '../../components/shared/Popover/DeleteConfirmationPopover';
import { toast } from 'react-toastify';
import { useApiCall } from '../../utils/hooks/useApiCall';
import { deleteClinicalStudy } from '../../services/clinicalStudiesServices';

const columns = [
  { label: 'Acronomo', key: 'acronym' },
  { label: 'Nome Estudo', key: 'name' },
  { label: 'ID Estudo', key: 'studyId' },
  { label: 'Industria', key: 'industry.name' },
  { label: 'Ações', key: 'actions' },
];

export const ClinicalStudiesPage = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [clinicalStudyData, setClinicalStudy] = useState<
    ClinicalStudyViewModel | undefined
  >();
  const [clinicalStudyLoading, setClinicalStudyLoading] = useState(false);
  const { data: clinicalStudies, refetch } =
    useQuery<ClinicalStudyViewModel[]>('/clinical-studies');
  const api = useApiCall();

  const handleClose = () => {
    setClinicalStudy(undefined);
    onClose();
  };

  const handleOpenEditModal = (usr: ClinicalStudyViewModel) => {
    setClinicalStudy(usr);
    onOpen();
  };

  const handleDelete = async (clinicalStudyId: number) => {
    try {
      setClinicalStudyLoading(true);
      await deleteClinicalStudy(clinicalStudyId, api);
      refetch();
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setClinicalStudyLoading(false);
    }
  };

  return (
    <>
      <ClinicalStudyModal
        clinicalStudy={clinicalStudyData}
        refetch={refetch}
        isOpen={isOpen}
        onClose={handleClose}
      />
      <PanelWrapper title="Estudos Clínicos">
        <FilterContainer onOpenModal={onOpen} />
        <Box className="rounded-lg shadow p-4 pt-10 mt-5">
          <Table>
            <Thead>
              <Tr>
                {columns.map((column) => (
                  <Th key={column.key}>{column.label}</Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {clinicalStudies?.map((row) => (
                <Tr
                  key={row.id}
                  className="hover:bg-gray-50 hover:cursor-pointer"
                >
                  <Td>{row.acronym}</Td>
                  <Td>{row.name}</Td>
                  <Td>{row.studyId}</Td>
                  <Td>{row.industry?.name}</Td>

                  <Td>
                    <div className="w-full flex justify-around">
                      <DeleteConfirmationPopover
                        loading={clinicalStudyLoading}
                        onConfirm={() => handleDelete(row.id)}
                      >
                        <IconButton
                          colorScheme="red"
                          aria-label="Excluir"
                          icon={<DeleteIcon color="white" />}
                        />
                      </DeleteConfirmationPopover>
                      <IconButton
                        onClick={() => handleOpenEditModal(row)}
                        colorScheme="blue"
                        aria-label="Editar"
                        icon={<EditIcon color="white" />}
                      />
                    </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </PanelWrapper>
    </>
  );
};
